import { FC } from 'react';
import { clx } from 'Utils';
import styles from 'partials/decoration/profile-decoration-box.module.scss';

export const SkeletonProfileDecorationBox: FC = (): JSX.Element => {
	return (
		<div
			className={clx(
				styles.body,
				'd-flex flex-column flex-md-row gap-3'
			)}>
			<div role="button" tabIndex={-1} className={styles.logo}>
				<div className={styles.logoBox}>
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							background: 'rgba(220,220,220,0.6)',
							borderRadius: 'inherit',
							animation:
								'skeleton-loading 1.2s infinite ease-in-out'
						}}
					/>
				</div>
			</div>
			<div className="flex-grow-1">
				<>
					<div
						style={{
							width: 180,
							height: 24,
							background: '#f2f2f4',
							borderRadius: 4,
							marginBottom: 12,
							animation:
								'skeleton-loading 1.2s infinite ease-in-out'
						}}
					/>
					<div
						style={{
							width: 120,
							height: 18,
							background: '#f2f2f4',
							borderRadius: 4,
							marginBottom: 12,
							animation:
								'skeleton-loading 1.2s infinite ease-in-out'
						}}
					/>
					<div
						style={{
							width: 220,
							height: 16,
							background: '#f2f2f4',
							borderRadius: 4,
							marginBottom: 8,
							animation:
								'skeleton-loading 1.2s infinite ease-in-out'
						}}
					/>
					<div
						style={{
							width: 100,
							height: 16,
							background: '#f2f2f4',
							borderRadius: 4,
							marginBottom: 8,
							animation:
								'skeleton-loading 1.2s infinite ease-in-out'
						}}
					/>
					<div
						style={{
							width: 160,
							height: 16,
							background: '#f2f2f4',
							borderRadius: 4,
							marginBottom: 8,
							animation:
								'skeleton-loading 1.2s infinite ease-in-out'
						}}
					/>
				</>
			</div>
		</div>
	);
};

// Add skeleton loading keyframes globally if not already present
// You may want to move this to your global CSS
const style = document.createElement('style');
style.innerHTML = `
@keyframes skeleton-loading {
	0% { opacity: 1; }
	50% { opacity: 0.4; }
	100% { opacity: 1; }
}`;
if (
	typeof document !== 'undefined' &&
	!document.getElementById('skeleton-loading-keyframes')
) {
	style.id = 'skeleton-loading-keyframes';
	document.head.appendChild(style);
}
